import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

const metadataSpacerStyles = xcss({
	marginLeft: 'space.050',
	marginRight: 'space.050',
});

export const Spacer: {
	(): React.JSX.Element;
	IS_METADATA_SPACER: boolean;
} = (): React.JSX.Element => (
	<Box as="span" xcss={metadataSpacerStyles}>
		•
	</Box>
);

Spacer.IS_METADATA_SPACER = true;
